import localStorageKey from "../../../../../enumerations/localStorageKey";
import { moneyFormat } from "../../../../../plugins/numberFormat";

const nowLang =
  window.localStorage.getItem(localStorageKey.DEFAULT_LANG) ?? process.env.REACT_APP_DEFAULT_LANG;

const renderGeneralWinlost = ({
  total_win_lose,
  status,
  showWinLostStatus = [],
  statusColor = {},
}) => {
  if (showWinLostStatus.length <= 0 || showWinLostStatus.includes(status)) {
    return (
      <span style={{ color: statusColor[status] ?? "inherit" }}>{moneyFormat(total_win_lose)}</span>
    );
  }
  return "-";
};

export const columnsSaba = (t) => {
  const SHOW_WIN_LOSS_STATUS = [4, 5, 6, 7, 8];
  // const SHOW_SETTLE_TIME = [4, 5, 6, 7, 8, 9, 10, 13];
  const STATUS_COLOR = {
    2: null,
    4: "var(--table-text-green)",
    5: "#EFAD5B",
    6: "var(--table-text-green)",
    7: "var(--table-text-red)",
    8: "#EFAD5B",
    10: null,
    11: null,
    12: null,
    13: null,
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "sport_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.sportTypeName}</> : <>{detail.sportTypeName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "transaction_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_amount",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_amount),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "winlost_amount",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (SHOW_WIN_LOSS_STATUS.includes(record.status)) {
          return [
            record.winlost_amount <= 0 ? (
              <span style={{ color: "var(--table-text-red)" }}>
                {moneyFormat(record.winlost_amount)}
              </span>
            ) : (
              <span style={{ color: "var(--table-text-green)" }}>
                {moneyFormat(record.winlost_amount)}
              </span>
            ),
          ];
        } else {
          return "-";
        }
      },
    },
    {
      title: t("mobile.betInquiry.odds"),
      dataIndex: "odds",
      width: 150,
      align: "center",
      render: (_, record) => {
        let odds = "-";
        if (!record?.txns && record.ticket_detail) {
          if (record?.ticket_detail?.length > 0) {
            odds = record?.ticket_detail[0]?.odds;
          }
        } else {
          if (record?.txns?.detail?.length > 0) {
            odds = record?.txns?.detail[0]?.odds;
          }
        }
        return <>{odds}</>;
      },
    },
    {
      title: t("mobile.betInquiry.leagueName"),
      dataIndex: "league_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.leagueName}</> : <>{detail.leagueName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.homeTeam"),
      dataIndex: "home_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.homeName}</> : <>{detail.homeName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.awayteam"),
      dataIndex: "away_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.awayName}</> : <>{detail.awayName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      render: (_, data) => (
        <span
          style={{
            color: `${STATUS_COLOR[data.status] ? STATUS_COLOR[data.status] : "inherit"}`,
          }}
        >
          {t(`mobile.betInquiry.saba.status${data.status}`)}
        </span>
      ),
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
  ];
};

export const columnsJollySport = (t) => {
  const SHOW_WIN_LOSS_STATUS = [4, 5, 6, 7, 8];
  // const SHOW_SETTLE_TIME = [4, 5, 6, 7, 8, 9, 10, 13];
  const STATUS_COLOR = {
    2: null,
    4: "var(--table-text-green)",
    5: "#EFAD5B",
    6: "var(--table-text-green)",
    7: "var(--table-text-red)",
    8: "#EFAD5B",
    10: null,
    11: null,
    12: null,
    13: null,
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "sport_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.sportTypeName}</> : <>{detail.sportTypeName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "transaction_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_amount",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_amount),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "winlost_amount",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (SHOW_WIN_LOSS_STATUS.includes(record.status)) {
          return [
            record.winlost_amount <= 0 ? (
              <span style={{ color: "var(--table-text-red)" }}>
                {moneyFormat(record.winlost_amount)}
              </span>
            ) : (
              <span style={{ color: "var(--table-text-green)" }}>
                {moneyFormat(record.winlost_amount)}
              </span>
            ),
          ];
        } else {
          return "-";
        }
      },
    },
    {
      title: t("mobile.betInquiry.odds"),
      dataIndex: "odds",
      width: 150,
      align: "center",
      render: (_, record) => {
        let odds = "-";
        if (!record?.txns && record.ticket_detail) {
          if (record?.ticket_detail?.length > 0) {
            odds = record?.ticket_detail[0]?.odds;
          }
        } else {
          if (record?.txns?.detail?.length > 0) {
            odds = record?.txns?.detail[0]?.odds;
          }
        }
        return <>{odds}</>;
      },
    },
    {
      title: t("mobile.betInquiry.leagueName"),
      dataIndex: "league_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.leagueName}</> : <>{detail.leagueName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.homeTeam"),
      dataIndex: "home_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.homeName}</> : <>{detail.homeName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.awayteam"),
      dataIndex: "away_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (!record?.txns && record.ticket_detail) {
          const detail = record?.ticket_detail[0];
          if (detail) {
            return nowLang === "zh" ? <>{detail.awayName}</> : <>{detail.awayName_en}</>;
          }
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      render: (_, data) => (
        <span
          style={{
            color: `${STATUS_COLOR[data.status] ? STATUS_COLOR[data.status] : "inherit"}`,
          }}
        >
          {t(`mobile.betInquiry.saba.status${data.status}`)}
        </span>
      ),
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
  ];
};

export const columnsBlockchain = (t) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_code",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (record?.game_code) {
          return <>{t(`blockchain.${record.game_code}`)}</>;
        } else {
          return "-";
        }
      },
    },
    {
      title: t("mobile.betInquiry.period"),
      dataIndex: "period",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betContent"),
      dataIndex: "choice_number",
      width: 150,
      align: "center",
      render: (_, data) =>
        data.game_code === "blockchain_4stars" ? (
          <span>{data.choice_number}</span>
        ) : (
          <span>
            {isNaN(parseInt(data.choice_number))
              ? t(`choice.item.${data.choice_number}`)
              : data.choice_number}
          </span>
        ),
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "total_win_lose",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.total_win_lose,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.odds"),
      dataIndex: "odds",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.lotteryNumber"),
      hideInSearch: true,
      dataIndex: "original_lottery_number",
      render: (_, data) => {
        if (data.original_lottery_number) {
          return <>{data.original_lottery_number.slice(-4)}</>;
        } else {
          return "-";
        }
      },
    },
  ];
};

export const columns77Lottery = (t, onLotteryNumberClick = () => {}) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_type",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (record?.game_type) {
          return <>{t(`lottery.gameType.${record.game_type}`)}</>;
        } else {
          return "-";
        }
      },
    },
    {
      title: t("mobile.betInquiry.period"),
      dataIndex: "period",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betContent"),
      dataIndex: "choice_number",
      width: 150,
      align: "center",
      render: (_, data) => {
        const itemSorting = (a, b) => {
          if (isNaN(parseInt(a)) && isNaN(parseInt(b))) {
            return 1;
          }
          return parseInt(a) - parseInt(b);
        };

        const valSplit = data?.choice_number?.split("|");
        if (valSplit) {
          return (
            `【${t(`gameWay.${data.game_way_type}`)}】` +
            valSplit
              .map((_val) => {
                return (
                  _val
                    .split(",")
                    .sort(itemSorting)
                    //because parseInt(7X)=7
                    .map((v) =>
                      v.includes("X")
                        ? t(`choice.item.${v}`)
                        : isNaN(parseInt(v)) && v !== "_" && v !== ""
                          ? t(`choice.item.${v}`)
                          : v,
                    )
                    .join(",")
                );
              })
              .join("|")
          );
        }
        return null;
      },
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "total_bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.total_bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.odds"),
      dataIndex: "odds",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.lotteryNumber"),
      dataIndex: "lottery_number",
      width: 150,
      align: "center",
      render: (_, data) => {
        if (data.lottery_number) {
          if (data.game_category_detail_type !== "LOTVNNEC") {
            return (
              <>
                {data?.lottery_number?.special_result_number
                  ? data?.lottery_number?.period_result_number?.join(",") +
                    "," +
                    data?.lottery_number?.special_result_number
                  : data?.lottery_number?.period_result_number?.join(",")}
              </>
            );
          } else {
            return (
              <a onClick={() => onLotteryNumberClick(data)}>{`${t(
                "LOTVN.result.special.prize",
              )}: ${data?.lottery_number?.period_result_number.slice(-1)}`}</a>
            );
          }
        } else {
          return "-";
        }
      },
    },
  ];
};

export const columnsWinLottery = (t) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_type",
      width: 150,
      align: "center",
      render: (_, record) => {
        return t([
          `${process.env.REACT_APP_WIN_TRAN_NAME}.winlottery.title.${record?.game_type}`,
          `game.winlottery.title.${record?.game_type}`,
        ]);
      },
    },
    {
      title: t("mobile.betInquiry.period"),
      dataIndex: "period",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betContent"),
      dataIndex: "choice_number",
      width: 150,
      align: "center",
      render: (_, data) => {
        const itemSorting = (a, b) => {
          if (isNaN(parseInt(a)) && isNaN(parseInt(b))) {
            return 1;
          }
          return parseInt(a) - parseInt(b);
        };

        const valSplit = data?.choice_number?.split("|");
        if (valSplit) {
          return valSplit
            .map((_val) => {
              return (
                _val
                  .split(",")
                  .sort(itemSorting)
                  //because parseInt(7X)=7
                  .map((v) =>
                    v.includes("X")
                      ? t(`choice.item.${v}`)
                      : isNaN(parseInt(v)) && v !== "_" && v !== ""
                        ? t(`choice.item.${v}`)
                        : v,
                  )
                  .join(",")
              );
            })
            .join("|");
        }
        return null;
      },
    },
    {
      title: t("mobile.betInquiry.lotteryNumber"),
      dataIndex: "lottery_number",
      width: 130,
      align: "center",
      render: (_, data) => {
        // if (data?.lottery_number?.period_result_number) {
        //   return <>{data.lottery_number.period_result_number[0]}</>;
        // } else if (data?.lottery_number?.period_result_bit) {
        //   const numberString = data.lottery_number.period_result_bit.current_amount;
        //   const chars = numberString.replace(".", "").slice(-3).split("");
        //   const sum = chars.reduce((_sum, num) => _sum + parseInt(num), 0);
        //   return <>{sum}</>;
        // }
        if (data.game_category_detail_type === "LOTBIT") {
          if (
            !data?.lottery_number?.period_result_bit?.current_amount ||
            !data?.lottery_number?.period_result_bit?.result
          ) {
            return "-";
          }
          return (
            <>
              {data?.lottery_number?.period_result_bit?.current_amount +
                ` (${t(`bitGame.gameResult.${data?.lottery_number?.period_result_bit?.result}`)})`}
            </>
          );
        } else {
          return (
            <>
              {!data?.lottery_number?.period_result_number
                ? "-"
                : data.lottery_number.period_result_number[0]}
            </>
          );
        }
      },
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.fee"),
      dataIndex: "fee",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.fee),
    },
    {
      title: t("mobile.betInquiry.odds"),
      dataIndex: "odds",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
  ];
};

export const columnsMinigame = (t) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_type",
      width: 150,
      align: "center",
      render: (_, record) => {
        return t([`game.name.${record?.game_type}`]);
      },
    },
    {
      title: t("mobile.betInquiry.period"),
      dataIndex: "period",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betContent"),
      dataIndex: "multiplier",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.lotteryNumber"),
      dataIndex: "lottery_number",
      width: 130,
      align: "center",
      render: (dom, record) => {
        if (dom) {
          return `${dom} x`;
        } else {
          return "-";
        }
      },
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
  ];
};

export const columnsMg = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "content_code",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (allGames) {
          const found = allGames?.find((item) => item.value === record.content_code);
          if (found) return found.label;
          return record.content_code;
        } else {
          return record.content_code;
        }
      },
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsT1 = (t) => {
  const SHOW_WIN_LOSS_STATUS = [1, 4, 5];
  const STATUS_COLOR = {
    4: "var(--table-text-green)",
    5: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_code",
      width: 150,
      align: "center",
      render: (_, record) => (
        <span style={{ textTransform: "capitalize" }}>{record.game_code}</span>
      ),
    },
    {
      title: t("mobile.betInquiry.period"),
      dataIndex: "period",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betContent"),
      dataIndex: "bet_details",
      width: 150,
      align: "center",
      render: (_, record) => {
        return record?.bet_details === null ? "-" : <span>{record?.bet_details}</span>;
      },
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //1下注  2取消 4已中奖 5未中奖
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`betInquiry.t1.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsEVO = (t) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_code",
      width: 150,
      align: "center",
      render: (_, record) => <span>{t(`evo.gameType.${record.game_code}`)}</span>,
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",

      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`betInquiry.evo.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 350,
      align: "center",
    },
  ];
};

export const columnsPP = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsPG = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsYGG = (t) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsEvoPlay = (t) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsJILI = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsSpribe = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsPT = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsPPLive = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsCQ9 = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsFC = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsPlayStar = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsWElottery = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsWElive = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsWEblockchain = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsTCG = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsJILIFish = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsYoubet = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsAESexy = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsSpribeOne = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsWEsport = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsLuckySport = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [1, 4, 5];
  const STATUS_COLOR = {
    4: "var(--table-text-green)",
    5: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "sport_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (record?.bet_details?.bets.length <= 1) {
          return record?.bet_details?.bets[0]?.sport_name;
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, record) => {
        return renderGeneralWinlost({
          total_win_lose: record.earn_point,
          status: record.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.odds"),
      dataIndex: "odds",
      width: 150,
      align: "center",
      render: (_, record) => {
        return <>{record?.bet_details?.k || "-"}</>;
      },
    },
    {
      title: t("mobile.betInquiry.leagueName"),
      dataIndex: "league_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (record?.bet_details?.bets.length <= 1) {
          return record?.bet_details?.bets[0]?.tournament_name;
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.homeTeam"),
      dataIndex: "home_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (record?.bet_details?.bets.length <= 1) {
          return record?.bet_details?.bets[0]?.competitor_name[0];
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.awayteam"),
      dataIndex: "away_name",
      width: 150,
      align: "center",
      render: (_, record) => {
        if (record?.bet_details?.bets.length <= 1) {
          return record?.bet_details?.bets[0]?.competitor_name[1];
        } else {
          return t("mobile.betInquiry.mixedParlay");
        }
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //1下注  2取消 4已中奖 5未中奖
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`betInquiry.t1.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
  ];
};

export const columnsYBSlot = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsWEfish = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsWEslot = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsFCFish = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsJDBFish = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsJDBSlot = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsViaCasinoLive = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [1, 4, 5];
  const STATUS_COLOR = {
    4: "var(--table-text-green)",
    5: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //1下注  2取消 4已中奖 5未中奖
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`betInquiry.t1.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsFFFLive = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsWCF = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEJDBSlot = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEJDFish = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEPP = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEPG = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEHACKSAW = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsONEJILISLOT = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsONEJILIFISH = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEJILICARD = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEJILICASINO = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEEVOLIVE = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEPPLIVE = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONESABA = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsONEGlobal = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsSBOSport = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsCRSport = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
export const columnsFBSport = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsAg = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};

export const columnsOmg = (t, allGames) => {
  const SHOW_WIN_LOSS_STATUS = [0, 1, 2, 3];
  const STATUS_COLOR = {
    1: "var(--table-text-green)",
    2: "var(--table-text-red)",
  };
  return [
    {
      title: t("mobile.betInquiry.username"),
      dataIndex: "account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.upperLevelAgentAccount"),
      dataIndex: "upper_agent_account",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.gameName"),
      dataIndex: "game_name",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.transactionTime"),
      dataIndex: "trans_time",
      width: 150,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.betAmount"),
      dataIndex: "bet_point",
      width: 150,
      align: "center",
      render: (_, record) => moneyFormat(record?.bet_point),
    },
    {
      title: t("mobile.betInquiry.winLoss"),
      dataIndex: "earn_point",
      width: 150,
      align: "center",
      render: (_, data) => {
        return renderGeneralWinlost({
          total_win_lose: data.earn_point,
          status: data.status,
          showWinLostStatus: SHOW_WIN_LOSS_STATUS,
          statusColor: STATUS_COLOR,
        });
      },
    },
    {
      title: t("mobile.betInquiry.status"),
      dataIndex: "status",
      width: 150,
      align: "center",
      //0下注 1已中奖 2未中奖 3结算中 4撤单 5已退单
      render: (_, data) => {
        return (
          <span style={{ color: STATUS_COLOR[data.status] ?? "inherit" }}>
            {t(`mobile.betInquiry.lottery.status${data.status}`)}
          </span>
        );
      },
    },
    {
      title: t("mobile.betInquiry.transId"),
      dataIndex: "trans_id",
      width: 160,
      align: "center",
    },
    {
      title: t("mobile.betInquiry.3th.transId"),
      dataIndex: "bet_id",
      width: 250,
      align: "center",
    },
  ];
};
